module.exports = __webpack_public_path__ + "img/qrcodeImg.40ac4c56.jpg";